import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on route change, or to the hash target when URL contains a hash.
 * Fixes: (1) pages not scrolling to top when navigating to legal pages
 *        (2) anchor links (#features, #pricing, #faq) not working when coming from other pages
 */
export function ScrollToTop(): null {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // The target may belong to a lazily loaded page (e.g. /confidentialite#cookies opened
      // from the cookie banner): start at the top, then keep looking for it for ~3 s.
      const id = decodeURIComponent(hash.slice(1));
      let attempts = 0;
      let timeoutId: ReturnType<typeof setTimeout>;
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (attempts === 0) window.scrollTo(0, 0);
        attempts += 1;
        if (attempts < 30) timeoutId = setTimeout(scrollToTarget, 100);
      };
      timeoutId = setTimeout(scrollToTarget, 100);
      return () => clearTimeout(timeoutId);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
